// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const HOME_SHOW_MORE_POSTS = "Zobraz \u010fal\u0161ie";
export const HOME_SUGGEST_ARTICLE = "Odporu\u010d \u010dl\u00e1nok na titulku";
